import {firebaseAuth} from '../../utils/firebase'
import { CLIENT_UID } from '../../utils/config'
import { ADMIN_LOGIN, ADMIN_LOGOUT } from './actionTypes'
import { showMessageModal } from './miscActions'

export const adminLogin = (data, history) => dispatch => {
  const { email, password } = data
  firebaseAuth.signInWithEmailAndPassword(email, password).then(function(user){
    if(user.user.uid === CLIENT_UID){
      dispatch({
        type: ADMIN_LOGIN
      })
      history.push('/admin/dashboard')
    }
  }).catch(function(error){
    const feedback={
      type: 'warning',
      txt: error.message
    }
    dispatch(showMessageModal(feedback))
  })
}

export const adminLogOut = () => ({
  type: ADMIN_LOGOUT
})